module.exports = __webpack_public_path__ + "img/tingchechang.3f8a31c6.jpg";